function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Typography from '../../Typography';
import ChevronDown from '@ellucian/ds-icons/lib/ChevronDown';
import { withStyles } from '@ellucian/react-design-system/core/styles';
import { getDefaultMaxDate, getDefaultMinDate } from './DateUtils';
import { withEDSContext } from '../../EDSContext/EDSContext';

import NativeSelect from '@material-ui/core/NativeSelect';

import { borderRadiusSmall, boxShadowFocus, fontFamilyHeader, fontSizeHeader3, fontWeightBold, spacing50, spacing30, spacing20, sizingSmall } from '../../styles/tokens';

var styles = function styles(theme) {
    return {
        caption: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            margin: spacing20 + ' ' + spacing50 + ' 0'
        },
        monthYearSelect: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            margin: '0 ' + spacing30
        },
        monthYearText: {
            flexGrow: 1,
            flexShrink: 1,
            textAlign: 'center',
            justifyContent: 'center'
        },
        monthYearSelectDropdown: {
            fontFamily: fontFamilyHeader,
            fontSize: fontSizeHeader3,
            fontWeight: fontWeightBold,
            '&:hover, &:focus': {
                backgroundColor: theme.palette.grey[250]
            },
            '&:focus': {
                boxShadow: boxShadowFocus,
                borderRadius: borderRadiusSmall
            }
        },
        monthYearSelectIcon: {
            top: 'calc(50% - ' + spacing30 + ')',
            height: sizingSmall,
            width: sizingSmall,
            fill: theme.palette.grey[500]
        },
        monthYearSelectMenu: {
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.fontSize,
            fontWeight: fontWeightBold
        }
    };
};

function Caption(_ref) {
    var classes = _ref.classes,
        classNames = _ref.classNames,
        date = _ref.date,
        edsContext = _ref.edsContext,
        id = _ref.id,
        locale = _ref.locale,
        localeUtils = _ref.localeUtils,
        maxDate = _ref.maxDate,
        minDate = _ref.minDate,
        months = _ref.months,
        onChange = _ref.onChange,
        onClick = _ref.onClick,
        startYear = _ref.startYear,
        endYear = _ref.endYear,
        withMonthYearSelect = _ref.withMonthYearSelect,
        rest = _objectWithoutProperties(_ref, ['classes', 'classNames', 'date', 'edsContext', 'id', 'locale', 'localeUtils', 'maxDate', 'minDate', 'months', 'onChange', 'onClick', 'startYear', 'endYear', 'withMonthYearSelect']);

    var captionMonths = localeUtils.getMonths(locale);

    var buildYearsOptions = function buildYearsOptions() {
        var years = [];
        for (var i = startYear; i <= endYear; i += 1) {
            years.push(i);
        }
        return years;
    };

    var handleChange = function handleChange(e, type) {
        if (type === 'year') {
            onChange(new Date(e.target.value, date.getMonth()));
        } else {
            // month
            onChange(new Date(date.getFullYear(), e.target.value));
        }
    };

    var monthSelector = React.createElement(
        NativeSelect,
        {
            disableUnderline: true,
            id: id + '-month-selector',
            key: id + '-month-selector',
            onChange: function onChange(e) {
                return handleChange(e, 'month');
            },
            IconComponent: ChevronDown,
            classes: {
                select: classes.monthYearSelectDropdown,
                icon: classes.monthYearSelectIcon
            },
            value: date.getMonth(),
            name: 'month',
            inputProps: {
                'aria-label': edsContext.formatMessage('component.DatePicker.monthPicker')
            }
        },
        captionMonths.map(function (month, i) {
            return React.createElement(
                'option',
                { key: i, value: i },
                month
            );
        })
    );

    var yearSelector = React.createElement(
        NativeSelect,
        {
            disableUnderline: true,
            id: id + '-year-selector',
            key: id + '-year-selector',
            onChange: function onChange(e) {
                return handleChange(e, 'year');
            },
            IconComponent: ChevronDown,
            classes: {
                select: classes.monthYearSelectDropdown,
                icon: classes.monthYearSelectIcon
            },
            value: date.getFullYear(),
            name: 'year',
            inputProps: {
                'aria-label': edsContext.formatMessage('component.DatePicker.yearPicker')
            }
        },
        buildYearsOptions().map(function (year) {
            return React.createElement(
                'option',
                { key: year, value: year },
                year
            );
        })
    );

    return React.createElement(
        'div',
        { className: 'DayPicker-Caption' },
        React.createElement(
            'div',
            { className: cn(_defineProperty({}, classes.caption, !withMonthYearSelect)) },
            withMonthYearSelect ? React.createElement(
                'div',
                { className: classes.monthYearSelect },
                [monthSelector, yearSelector]
            ) : React.createElement(
                Typography,
                {
                    variant: 'h3',
                    className: classes.monthYearText,
                    component: 'div',
                    align: 'center'
                },
                localeUtils.formatMonthTitle(date, locale)
            )
        )
    );
}

Caption.propTypes = {
    classes: PropTypes.object,
    classNames: PropTypes.object,
    date: PropTypes.instanceOf(Date),
    edsContext: PropTypes.object,
    endYear: PropTypes.number,
    id: PropTypes.string,
    locale: PropTypes.string,
    localeUtils: PropTypes.object,
    maxDate: PropTypes.instanceOf(Date),
    minDate: PropTypes.instanceOf(Date),
    months: PropTypes.arrayOf(PropTypes.string),
    monthYearSelectOptions: PropTypes.object,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    startYear: PropTypes.number,
    withMonthYearSelect: PropTypes.bool
};

Caption.defaultProps = {
    endYear: getDefaultMaxDate().getFullYear(),
    startYear: getDefaultMinDate().getFullYear()
};

export default withEDSContext(withStyles(styles)(Caption));